import {
  LIFE_STAGE,
  COVER_TYPE
} from '~/constants/form.strings'

export const PAGE_DATA = {
  validAge: [16, 120],

  healthCover: [
    {
      label: 'Cheaper cover',
      value: 'Cheaper cover'
    },
    {
      label: 'Better hospital and/or extras cover',
      value: 'Better hospital and/or extras cover'
    },
    {
      label: 'My (or family\'s) specific health concern',
      value: 'My (or family\'s) specific health concern'
    },
    {
      label: 'Avoiding the Medicare Levy Surcharge (MLS)',
      value: 'Avoiding the Medicare Levy Surcharge (MLS)'
    },
    {
      label: 'Planning on having a baby',
      value: 'Planning on having a baby'
    },
    {
      label: 'Change of circumstances',
      value: 'Change of circumstances'
    },
    {
      label: 'New arrival to Australia',
      value: 'New arrival to Australia'
    },
    {
      label: 'Health cover required as a condition of visa',
      value: 'Health cover required as a condition of visa'
    }
  ],

  healthCoverAB1: [
    {
      label: 'Better hospital and/or extras cover',
      value: 'Better hospital and/or extras cover'
    },
    {
      label: 'Cheaper cover',
      value: 'Cheaper cover'
    },
    {
      label: 'My (or family\'s) specific health concern',
      value: 'My (or family\'s) specific health concern'
    },
    {
      label: 'Avoiding the Medicare Levy Surcharge (MLS)',
      value: 'Avoiding the Medicare Levy Surcharge (MLS)'
    },
    {
      label: 'Planning on having a baby',
      value: 'Planning on having a baby'
    },
    {
      label: 'Change of circumstances',
      value: 'Change of circumstances'
    },
    {
      label: 'New arrival to Australia',
      value: 'New arrival to Australia'
    },
    {
      label: 'Health cover required as a condition of visa',
      value: 'Health cover required as a condition of visa'
    }
  ],
  
  healthCoverAB2: [
    {
      label: 'Better hospital and/or extras cover',
      value: 'Better hospital and/or extras cover'
    },
    {
      label: 'My (or family\'s) specific health concern',
      value: 'My (or family\'s) specific health concern'
    },
    {
      label: 'Avoiding the Medicare Levy Surcharge (MLS)',
      value: 'Avoiding the Medicare Levy Surcharge (MLS)'
    },
    {
      label: 'Planning on having a baby',
      value: 'Planning on having a baby'
    },
    {
      label: 'Change of circumstances',
      value: 'Change of circumstances'
    },
    {
      label: 'New arrival to Australia',
      value: 'New arrival to Australia'
    },
    {
      label: 'Health cover required as a condition of visa',
      value: 'Health cover required as a condition of visa'
    },
    {
      label: 'Cheaper cover',
      value: 'Cheaper cover'
    }
  ],

  healthCoverFunnelAB: [
    {
      label: 'Cheaper cover',
      value: 'Cheaper cover',
      image: '/icons/Coins.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      label: 'Get comprehensive protection',
      value: 'Better hospital and/or extras cover',
      image: '/icons/ThumbsUp.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      label: 'Cover for a specific health issue',
      value: 'My (or family\'s) specific health concern',
      image: '/icons/Heartbeat-Regular.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      label: 'Avoid the Medicare Levy Surcharge',
      value: 'Avoiding the Medicare Levy Surcharge (MLS)',
      image: '/icons/Lights.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      label: 'Planning to have a baby',
      value: 'Planning on having a baby',
      image: '/icons/Pregnancy.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      label: 'Recent life changes',
      value: 'Change of circumstances',
      image: '/icons/ArrowClockwise-Regular.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      label: 'New to Australia',
      value: 'New arrival to Australia',
      image: '/icons/AirplaneTilt-Regular.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      label: 'Need cover for a visa requirement',
      value: 'Health cover required as a condition of visa',
      image: '/icons/Notebook.svg',
      imageWidth: 40,
      imageHeight: 40
    }
  ],

  incomes: {
    single: [
      {
        label: '$105,000 or less (Base tier)',
        desc: 'A 24.118% (Base tier) government rebate will be applied.',
        value: 'nil',
        tierLabel: 'Base Tier',
        rebate: 24.118,
        idSuffix: 'annualincome-nil',
        income: '$105,000 or less'
      },
      {
        label: '$105,001 - $123,000 (Tier 1)',
        desc: 'A 16.079% (Tier 1) government rebate will be applied.',
        value: 'low',
        rebate: 16.079,
        idSuffix: 'annualincome-low',
        income: '$105,001 - $123,000',
        tierLabel: 'Tier 1'
      },
      {
        label: '$123,001 - $164,000 (Tier 2)',
        desc: 'A 8.038% (Tier 2) government rebate will be applied.',
        value: 'medium',
        rebate: 8.038,
        idSuffix: 'annualincome-medium',
        income: '$123,001 - $164,000',
        tierLabel: 'Tier 2'
      },
      {
        label: '$164,001 or more (no rebate) (Tier 3)',
        desc: 'No government rebate (Tier 3) will be applied.',
        value: 'high',
        rebate: '0.00',
        idSuffix: 'annualincome-high',
        income: '$164,001 or more',
        tierLabel: 'Tier 3'
      },
      {
        label: 'Do not apply rebate',
        desc: 'We will not apply Government rebate.',
        value: 'none',
        rebate: '0.00',
        idSuffix: 'none',
        income: '$0',
        tierLabel: ''
      }
    ],
    couple: [
      {
        label: '$210,000 or less (Base tier)',
        desc: 'A 24.118% (Base tier) government rebate will be applied.',
        value: 'nil',
        rebate: 24.118,
        idSuffix: 'annualincome-nil',
        income: '$210,000 or less',
        tierLabel: 'Base Tier'
      },
      {
        label: '$210,001 - $246,000 (Tier 1)',
        desc: 'A 16.079% (Tier 1) government rebate will be applied.',
        value: 'low',
        rebate: 16.079,
        idSuffix: 'annualincome-low',
        income: '$210,001 - $246,000',
        tierLabel: 'Tier 1'
      },
      {
        label: '$246,001 - $328,000 (Tier 2)',
        desc: 'A 8.038% (Tier 2) government rebate will be applied.',
        value: 'medium',
        tierLabel: 'Tier 2',
        rebate: 8.038,
        idSuffix: 'annualincome-medium',
        income: '$246,001 - $328,000'
      },
      {
        label: '$328,001 or more (no rebate) (Tier 3)',
        desc: 'No government rebate (Tier 3) will be applied.',
        value: 'high',
        rebate: 0,
        idSuffix: 'annualincome-high',
        income: '$328,001 or more',
        tierLabel: 'Tier 3'
      },
      {
        label: 'Do not apply rebate',
        desc: 'We will not apply Government rebate.',
        value: 'none',
        rebate: 0,
        idSuffix: 'annualincome-none',
        income: '$0',
        tierLabel: ''
      }
    ]
  },
  
  incomesAB: {
    single: [
      {
        label: '$105,000 or less',
        desc: 'A 24.118% (Base tier) government rebate will be applied.',
        value: 'nil',
        tierLabel: 'Base Tier',
        rebate: 24.118,
        idSuffix: 'annualincome-nil',
        income: '$105,000 or less',
        info: {
          content: 'A 24.118% (Base tier) government rebate will be applied.'
        }
      },
      {
        label: '$105,001 to $123,000',
        desc: 'A 16.079% (Tier 1) government rebate will be applied.',
        value: 'low',
        rebate: 16.079,
        idSuffix: 'annualincome-low',
        income: '$105,001 - $123,000',
        tierLabel: 'Tier 1',
        info: {
          content: 'A 16.079% (Tier 1) government rebate will be applied.'
        }
      },
      {
        label: '$123,001 to $164,000',
        desc: 'A 8.038% (Tier 2) government rebate will be applied.',
        value: 'medium',
        rebate: 8.038,
        idSuffix: 'annualincome-medium',
        income: '$123,001 - $164,000',
        tierLabel: 'Tier 2',
        info: {
          content: 'A 8.038% (Tier 2) government rebate will be applied.'
        }
      },
      {
        label: '$164,001 or more',
        desc: 'No government rebate (Tier 3) will be applied.',
        value: 'high',
        rebate: '0.00',
        idSuffix: 'annualincome-high',
        income: '$164,001 or more',
        tierLabel: 'Tier 3',
        info: {
          content: 'No government rebate (Tier 3) will be applied.'
        }
      },
      {
        label: 'Do not apply rebate',
        desc: 'We will not apply Government rebate.',
        value: 'none',
        rebate: '0.00',
        idSuffix: 'none',
        income: '$0',
        tierLabel: ''
      }
    ],
    couple: [
      {
        label: '$210,000 or less',
        desc: 'A 24.118% (Base tier) government rebate will be applied.',
        value: 'nil',
        rebate: 24.118,
        idSuffix: 'annualincome-nil',
        income: '$210,000 or less',
        tierLabel: 'Base Tier',
        info: {
          content: 'A 24.118% (Base tier) government rebate will be applied.'
        }
      },
      {
        label: '$210,001 to $246,000',
        desc: 'A 16.079% (Tier 1) government rebate will be applied.',
        value: 'low',
        rebate: 16.079,
        idSuffix: 'annualincome-low',
        income: '$210,001 - $246,000',
        tierLabel: 'Tier 1',
        info: {
          content: 'A 16.079% (Tier 1) government rebate will be applied.'
        }
      },
      {
        label: '$246,001 to $328,000',
        desc: 'A 8.038% (Tier 2) government rebate will be applied.',
        value: 'medium',
        tierLabel: 'Tier 2',
        rebate: 8.038,
        idSuffix: 'annualincome-medium',
        income: '$246,001 - $328,000',
        info: {
          content: 'A 8.038% (Tier 2) government rebate will be applied.'
        }
      },
      {
        label: '$328,001 or more',
        desc: 'No government rebate (Tier 3) will be applied.',
        value: 'high',
        rebate: 0,
        idSuffix: 'annualincome-high',
        income: '$328,001 or more',
        tierLabel: 'Tier 3',
        info: {
          content: 'No government rebate (Tier 3) will be applied.'
        }
      },
      {
        label: 'Do not apply rebate',
        desc: 'We will not apply Government rebate.',
        value: 'none',
        rebate: 0,
        idSuffix: 'annualincome-none',
        income: '$0',
        tierLabel: ''
      }
    ]
  },

  hospitalCoverList: [
    {
      label: 'Private Hospital',
      value: 'private_hospital_shared',
      info: {
        title: 'Private Hospital',
        content: 'Private patient, private hospital admissions.'
      }
    },
    {
      label: 'Ambulance',
      value: 'ambulance',
      info: {
        title: 'Ambulance',
        content: 'Cover for all clinically necessary ambulance services for emergencies in Australia. This differs in states. For more details check with state Ambulance authority to ensure you have the right level of cover for non-emergency ambulance transport within Australia.'
      }
    },
    {
      label: 'Heart and Vascular System',
      value: 'heart_vascular',
      info: {
        title: 'Heart and Vascular System',
        content: 'Hospital treatment for the investigation and treatment of the heart, heart-related conditions and vascular system.'
      }
    },
    {
      value: 'eye_not_cataracts',
      label: 'Eye (not cataracts)',
      info: {
        title: 'Eye (not cataracts)',
        content: 'Hospital treatment for the investigation and treatment of the eye and the contents of the eye socket.'
      }
    },
    {
      value: 'chemotherapy_radiotherapy_immunotherapy',
      label: 'Cancer',
      info: {
        title: 'Cancer',
        content: 'Hospital treatment for chemotherapy, radiotherapy and immunotherapy of cancer. Surgical treatment of other body systems i.e. lung and chest are covered separately.'
      }
    },
    {
      value: 'joint_replacement',
      label: 'Joint replacements',
      info: {
        title: 'Joint replacements',
        content: 'Hospital treatment for surgery for joint replacements, including revisions, resurfacing, partial replacements and removal of prostheses'
      }
    },
    {
      value: 'rehabilitation',
      label: 'Rehabilitation',
      info: {
        title: 'Rehabilitation',
        content: 'Hospital treatment for physical rehabilitation for a patient related to surgery or illness.'
      }
    },
    {
      value: 'plastic_reconstructive_surgery',
      label: 'Plastic and Reconstructive Surgery (medically necessary)',
      info: {
        title: 'Plastic and Reconstructive Surgery (medically necessary)',
        content: 'Hospital treatment which is medically necessary for the investigation and treatment of any physical deformity, whether acquired as a result of illness or accident, or congenital.'
      }
    },
    {
      value: 'pregnancy_birth',
      label: 'Pregnancy and Birth',
      info: {
        title: 'Pregnancy and Birth',
        content: 'Hospital treatment for investigation and treatment of conditions associated with pregnancy and child birth. Treatment for the baby is covered under the clinical category relevant to their condition.'
      }
    },
    {
      value: 'cataracts',
      label: 'Cataracts',
      info: {
        title: 'Cataracts',
        content: 'Hospital treatment for surgery to remove a cataract and replace with an artificial lens.'
      }
    },
    {
      value: 'dialysis_chronic_kidney',
      label: 'Dialysis for chronic kidney disease',
      info: {
        title: 'Dialysis for chronic kidney disease',
        content: 'Hospital treatment for dialysis treatment for chronic kidney failure.'
      }
    },
    {
      value: 'hearing_device',
      label: 'Implantation of hearing devices',
      info: {
        title: 'Implantation of hearing devices',
        content: 'Hospital treatment to correct hearing loss, including implantation of a prosthetic hearing device.'
      }
    },
    {
      value: 'assisted_reproductive',
      label: 'Assisted Reproductive Services',
      info: {
        title: 'Assisted Reproductive Services',
        content: 'Hospital treatment for fertility treatments or procedures.'
      }
    },
    {
      value: 'male_reproductive_system',
      label: 'Male Reproductive System',
      info: {
        title: 'Male Reproductive System',
        content: 'Hospital treatment for the investigation and treatment of the male reproductive system including the prostate.'
      }
    },
    {
      value: 'hospital_psychiatric_service',
      label: 'Hospital psychiatric services',
      info: {
        title: 'Hospital psychiatric services',
        content: 'Hospital treatment for the treatment and care of patients with psychiatric, mental, addiction or behavioural disorders.'
      }
    },
    {
      value: 'weight_loss_surgery',
      label: 'Weight loss surgery',
      info: {
        title: 'Weight loss surgery',
        content: 'Hospital treatment for surgery that is designed to reduce a person’s weight, remove excess skin due to weight loss and reversal of a bariatric procedure.'
      }
    },
    {
      value: 'ear_nose_throat',
      label: 'Ear, Nose and Throat',
      info: {
        title: 'Ear, Nose and Throat',
        content: 'Hospital treatment for the investigation and treatment of the ear, nose, throat, middle ear, thyroid, parathyroid, larynx, lymph nodes and related areas of the head and neck.'
      }
    },
    {
      value: 'pain_management',
      label: 'Pain Management',
      info: {
        title: 'Pain Management',
        content: 'Hospital treatment for pain management that does not require the insertion or surgical management of a device'
      }
    }
  ],

  hospitalCoverLevel: [
    'None',
    'Basic',
    'Bronze',
    'Silver',
    'Gold'
  ],

  extraCoverLevel: [
    'None',
    'Low',
    'Medium',
    'High'
  ],

  // Keyed by the verbatim choosable-extra display_name returned by
  // /product/choosable-extras (HI-621/HI-622) -- these are the literal HCF/Bupa
  // "Applicable Extras" bundle names, not derived from any Cover record.
  //
  // The 16 entries below with no `info` block are genuinely new bundle names (or
  // compound bundles / distinct-scope items) introduced by HI-621/HI-622 that have
  // no existing tooltip copy to reuse -- real copy for these still needs product/
  // marketing sign-off (see HI-622 Open Question #2), so they're left without a
  // tooltip rather than having copy invented for them: Orthodontics, Physiotherapy
  // & Exercise Physiology, Podiatry (Orthotics not included), Vaccines, Natural
  // Therapies, Health Management Programs, Mental Health Services, Speech
  // Pathology & Occupational Therapy, Dietician, Ante Natal - Midwife, Chinese
  // Herbalism, Dietary, Major Dental & Endodontic, Mental Health (incl.
  // Psychology), Non PBS Pharmaceuticals, Podiatry & Foot Orthotics.
  extrasCoverList: [
    {
      label: 'General Dental',
      value: 'General Dental',
      info: {
        title: 'General Dental',
        content: 'Routine dental care such as check-ups, cleaning, fillings and extractions.'
      }
    },
    {
      label: 'Major Dental',
      value: 'Major Dental',
      info: {
        title: 'Major Dental',
        content: 'Dental treatment beyond general care, such as crowns, bridges, root canals and dentures.'
      }
    },
    {
      label: 'Optical',
      value: 'Optical',
      info: {
        title: 'Optical',
        content: 'Cover for prescription glasses, contact lenses and eye tests.'
      }
    },
    {
      label: 'Physiotherapy',
      value: 'Physiotherapy',
      info: {
        title: 'Physiotherapy',
        content: 'Treatment for injury, pain and mobility issues provided by a registered physiotherapist.'
      }
    },
    {
      label: 'Chiropractic & Osteopathy',
      value: 'Chiropractic & Osteopathy',
      info: {
        title: 'Chiropractic & Osteopathy',
        content: 'Treatment for musculoskeletal conditions provided by a registered chiropractor or osteopath.'
      }
    },
    {
      label: 'Remedial Massage',
      value: 'Remedial Massage',
      info: {
        title: 'Remedial Massage',
        content: 'Massage therapy provided by a registered remedial massage therapist to treat muscle and soft tissue conditions.'
      }
    },
    {
      label: 'Acupuncture',
      value: 'Acupuncture',
      info: {
        title: 'Acupuncture',
        content: 'Treatment provided by a registered acupuncturist.'
      }
    },
    {
      label: 'Hearing Aids',
      value: 'hearing_aids',
      info: {
        title: 'Hearing Aids',
        content: 'Cover for the purchase, fitting and maintenance of hearing aids.'
      }
    },
    {
      label: 'Other Aids',
      value: 'glucose_monitor',
      info: {
        title: 'Other Aids',
        content: 'Cover for health aids and monitoring equipment such as glucose monitors.'
      }
    },
    {
      label: 'Digital Mental Health',
      value: 'Digital Mental Health',
      info: {
        title: 'Digital Mental Health',
        content: 'Cover for approved online and app-based mental health programs.'
      }
    },
    {
      label: 'Exercise Physiology',
      value: 'Exercise Physiology',
      info: {
        title: 'Exercise Physiology',
        content: 'Treatment provided by a registered exercise physiologist to manage injury, chronic conditions or disability.'
      }
    },
    {
      label: 'Eye Therapy',
      value: 'Eye Therapy',
      info: {
        title: 'Eye Therapy',
        content: 'Non-surgical treatment for vision and eye conditions provided by a registered practitioner.'
      }
    },
    {
      label: 'Home Nursing',
      value: 'Home Nursing',
      info: {
        title: 'Home Nursing',
        content: 'Nursing care provided in the home following illness, injury or surgery.'
      }
    },
    {
      label: 'Occupational Therapy',
      value: 'Occupational Therapy',
      info: {
        title: 'Occupational Therapy',
        content: 'Treatment provided by a registered occupational therapist to support daily living and work activities.'
      }
    },
    {
      label: 'Orthodontic',
      value: 'Orthodontic',
      info: {
        title: 'Orthodontic',
        content: 'Treatment to correct the position of teeth and jaws, such as braces and aligners.'
      }
    },
    {
      label: 'Speech Therapy',
      value: 'Speech Therapy',
      info: {
        title: 'Speech Therapy',
        content: 'Treatment provided by a registered speech pathologist for speech, language and communication difficulties.'
      }
    },
    // -- New bundle names introduced by HI-621/HI-622, tooltip copy pending sign-off --
    { label: 'Orthodontics', value: 'Orthodontics' },
    { label: 'Physiotherapy & Exercise Physiology', value: 'Physiotherapy & Exercise Physiology' },
    { label: 'Podiatry (Orthotics not included)', value: 'Podiatry (Orthotics not included)' },
    { label: 'Vaccines', value: 'Vaccines' },
    { label: 'Natural Therapies', value: 'Natural Therapies' },
    { label: 'Health Management Programs', value: 'Health Management Programs' },
    { label: 'Mental Health Services', value: 'Mental Health Services' },
    { label: 'Speech Pathology & Occupational Therapy', value: 'Speech Pathology & Occupational Therapy' },
    { label: 'Dietician', value: 'Dietician' },
    { label: 'Ante Natal - Midwife', value: 'Ante Natal - Midwife' },
    { label: 'Chinese Herbalism', value: 'Chinese Herbalism' },
    { label: 'Dietary', value: 'Dietary' },
    { label: 'Major Dental & Endodontic', value: 'Major Dental & Endodontic' },
    { label: 'Mental Health (incl. Psychology)', value: 'Mental Health (incl. Psychology)' },
    { label: 'Non PBS Pharmaceuticals', value: 'Non PBS Pharmaceuticals' },
    { label: 'Podiatry & Foot Orthotics', value: 'Podiatry & Foot Orthotics' }
  ],

  quickTips: {
    1: [
      'We are Australian owned.',
      'We make <strong>switching easy</strong>.',
      'We\'ve been helping Aussies save on their health insurance <strong>since 2010</strong>.'
    ],
    2: [
      '<strong>Compare Club</strong> compares selected products from a panel of trusted insurers. We do not compare all insurers or all products in the market.',
      'We\'re <strong>independently owned</strong>. Unlike some of our competitors, we aren\'t owned by any insurers (or vice versa).'
    ]
  },

  visaType: {
    visitor: [
      '600 - Visitor',
      '601 - Electronic Travel Authority',
      '461 - New Zealand Citizen Family Relationship (temporary) visa',
      '651 - eVisitor',
      '771 - Transit visa',
      '804 - Aged Parent visa',
      '870 - Sponsored Parent (Temporary) visa',
      '884 - Contributory Aged Parent (Temporary) visa',
      '866 - Protection visa'
    ],
    working: [
      '408 - Temporary Activity visa',
      '482 - Temporary Skill Shortage visa',
      '491 - Skilled Work Regional (Provisional) visa',
      '485 - Temporary Graduate visa',
      '407 - Training visa',
      '417 - Working Holiday visa',
      '462 - Work and Holiday visa',
      '188 - Business Innovation and Investment (provisional) visa',
      '190 - Skilled Nominated visa'
    ],
    student: [
      '500 - Student visa',
      '485 - Temporary Graduate visa',
      '570 - Independent ELICOS Sector visa',
      '571 - School Sector visa',
      '572 - Vocational Education and Training Sector visa',
      '573 - Higher Education Sector visa',
      '574 - Postgraduate Research Sector visa',
      '580 - Student Guardian visa'
    ],
    others: [
      '10 - Bridging visa A – BVA',
      '20 - Bridging visa B – BVB',
      '30 - Bridging visa C – BVC',
      '50 - Bridging visa E – BVE',
      '101 - Child visa',
      '102 - Adoption visa',
      '103 - Parent visa',
      '114 - Aged Dependent Relative visa',
      '115 - Remaining Relative visa',
      '116 - Carer visa',
      '117 - Orphan Relative',
      '119 - Regional Sponsor Migration Scheme',
      '120 - Labour Agreement visa',
      '121 - Employer Nomination Scheme',
      '124 - Distinguished Talent visa',
      '132 - Business Talent (Permanent) visa',
      '143 - Contributory Parent visa',
      '151 - Former Resident visa',
      '155 - Resident Return visa',
      '160 - Business Skills (Provisional) visa',
      '173 - Contributory Parent (Temporary) visa',
      '175 - Skilled Independent visa',
      '176 - Skilled Sponsored visa',
      '186 - Employer Nomination Scheme',
      '187 - Regional Sponsored Migration Scheme',
      '189 - Skilled Independent visa',
      '191 - Permanent Residence (Skilled Regional) visa',
      '200 - Refugee visas',
      '202 - Global Special Humanitarian',
      '300 - Prospective Marriage visa',
      '309 - Partner (Provisional and Migrant) visa',
      '400 - Temporary Work (Short Stay Specialist) visa',
      '401 - Temporary Work (long Stay Activity) visa',
      '402 - Training and Research visa',
      '403 - Temporary Work (International Relations) visa',
      '405 - Investor Retirement visa',
      '406 - Government Agreement visa',
      '410 - Retirement visa',
      '411 - Exchange visa',
      '415 - Foreign Government Agency',
      '416 - Special Program visa ',
      '419 - Visiting Academic visa',
      '420 - Temporary Work (Entertainment) visa',
      '421 - Sport visa',
      '422 - Medical Practitioner visa',
      '423 - Media and Film Staff visa',
      '426 - Domestic Worker (Temporary) Diplomatic and Consular visa',
      '427 - Domestic Worker (Temporary) Executive visa',
      '428 - Religious Worker visa',
      '444 - Special Category visa',
      '445 - Dependent Child visa',
      '456 - Business (Short Stay) visa',
      '457 - Temporary Work (Skilled) visa',
      '475 - Skilled Regional Sponsored visa',
      '476 - Skilled-Recognised Graduate visa',
      '487 - Skilled Regional Sponsored',
      '488 - Superyacht Crew visa',
      '489 - Skilled Regional (provisional) visa',
      '494 - Skilled Employer Sponsored Regional (provisional) visa',
      '495 - Skilled Independent Regional (Provisional) visa',
      '496 - Skilled Designated Area Sponsored visa',
      '570 - Independent ELICOS Sector visa',
      '571 - School Sector visa',
      '572 - Vocational Education and Training Sector visa',
      '573 - Higher Education Sector visa',
      '574 - Postgraduate Research Sector visa',
      '575 - Non Award Sector visa',
      '576 - Foreign Affairs or Defence sector visa',
      '580 - Student Guardian visa',
      '590 - Student Guardian visa',
      '602 - Medical Treatment visa',
      '675 - Medical Treatment (Short Stay) visa',
      '676 - Tourist visa',
      '685 - Medical Treatment Long Stay visa',
      '785 - Temporary Protection visa',
      '790 - Safe Haven Enterprise visa',
      '802 - Child visa',
      '808 - Confirmatory (Residence) visa',
      '820 - Partner visa',
      '835 - Remaining Relative visa',
      '836 - Carer visa',
      '837 - Orphan Relative',
      '838 - Aged Dependent Relative visa',
      '845 - Established Business in Australia visa',
      '846 - State or Territory Sponsored Regional Established Business in Australia visa',
      '855 - Labour Agreement visa',
      '858 - Global Talent visa',
      '864 - Contributory Aged Parent visa',
      '885 - Skilled Independent visa',
      '886 - Sponsored visa',
      '887 - Skilled Regional visa',
      '888 - Business Innovation and Investment (permanent) visa',
      '890 - Business Owner',
      '891 - Investor visa',
      '892 - State or Territory Sponsored Business Owner visa',
      '893 - State or Territory Sponsored Investor visa',
      '942 - Crew Travel Authority visa',
      '956 - Electronic Travel Authority (Business Entrant) visa',
      '976 - Electronic Travel Authority (Visitor) visa',
      '988 - Maritime Crew visa'
    ]
  },

  didYouKnow: 'Over the last 12 months, we\'ve helped families in Sydney\'s inner west <strong>save an average of $300</strong> on hospital and extras cover.',

  ovhcOffers: [
    'Satisfy Australian Government visa requirements',
    'Receive your visa compliance letter instantly by email',
    'Cut down on medical costs and protect your health Australia-wide'
  ],

  preVariansOffers: [
    'We don\'t inflate the price and take a cut',
    'We handle the switch for you and the paperwork that comes with it at no cost to you'
  ],

  preVariansOffersVariation: [
    'Hassle-free switching with all paperwork handled.',
    'Previously served waiting periods carry over.',
    'Access offers from various funds.'
  ],

  stepsToFollow: [
    {
      // imageUrl: require('~/static/images/steps/find-cover.svg')
      imageUrl: 'images/steps/find-cover.svg',
      text: 'Find Cover You Want',
      desc: 'Enter a few details and we’ll help you find the policies that better suits your needs.'
    },
    {
      // imageUrl: require('~/static/images/steps/simple-comparison.svg'),
      imageUrl: 'images/steps/simple-comparison.svg',
      text: 'Simple Comparison',
      desc: 'Let us know what type of cover you would like and we\'ll let you know what you\'ll be covered for.'
    },
    {
      // imageUrl: require('~/static/images/steps/get-quotes.svg'),
      imageUrl: 'images/steps/get-quotes.svg',
      text: 'Avoid Hefty Bills',
      desc: 'Overseas Visitors Health Cover can help you avoid hefty health care bills.'
    },
    {
      imageUrl: `${APP_ASSET_BASEURL}edge/static/images/steps/approval.svg`,
      text: 'Meet Visa Requirements',
      desc: 'We only offer policies that fulfill the visa requirements set by the Australian Government.'
    }
  ],

  criteriaList: [
    'Provides public hospital cover at <strong>a minimum</strong>',
    'Includes cover for <strong>emergency ambulance transport</strong>',
    '<strong>Covers all medications</strong> covered by the Pharmaceutical Benefits Scheme (PBS)',
    '<strong>Covers all treatments</strong> listed under the Medicare Benefits Schedule (MBS)'
  ],

  ovhcFaqs: [
    {
      title: 'What visas are covered under Overseas Visitors Health Cover (OVHC)?',
      content: `
        We cover all ‘active’ visas, such as working visas (485, 482, 408) and visitor visas (600, 601).
        <br /><br />
        There are some visas that are no longer active which health funds won’t cover, and you can’t get cover for any visa that has access to Medicare, such as visa 804 and visa 864.
      `
    },
    {
      title: 'Can I organise my cover before coming to Australia?',
      content: 'Yes. Our experts are able to help you get your cover sorted before coming to Australia, and you can call us internationally to get it sorted. We can even help with a certificate of insurance if that’s needed for your visa type.'
    },
    {
      title: 'When can I start using my cover?',
      content: `
        Your membership will commence on the date you nominated as the cover start date, even if your membership card has not arrived. However you should note that waiting periods will apply before you can make a claim.
        <br /><br />
        You will have seen these when you compared insurers, however the information will also be available in the welcome email sent by your chosen insurer.
      `
    },
    {
      title: 'Does Overseas Visitor Health Cover include extras, such as dental and optical?',
      content: 'Most policies do not include extras, but can be added to the cover if required. Most Overseas Visitors Health Cover includes hospital and ambulance with the option to add benefits for doctors, specialists and pathology (blood tests).'
    },
    {
      title: 'How do I make an Overseas Visitors Health Cover claim?',
      content: `
        It depends on your insurer, but you can make a claim by providing the receipt and claiming online or through the insurer’s mobile app.
        <br /><br />
        However, most doctors and General Practitioners will recognise some health funds and let you claim on the spot with your membership card.
      `
    },
    {
      title: 'What happens if the date I\'m arriving in Australia changes?',
      content: 'All you have to do is contact your insurer or us prior to the start date of your cover so it can be changed. You should do this as soon as you know about the delay.'
    },
    {
      title: 'When will I be charged?',
      content: `
        You will be billed for your first month as soon as you sign up for your policy to confirm your cover. This payment will cover the month that follows your policy start date.
        <br /><br />
        When this period ends, you will be charged for the next billing period, which may be fortnightly or monthly.
      `
    },
    {
      title: 'What if my membership card doesn\'t arrive before I leave my overseas address?',
      content: `
        If you were overseas at the time of purchase and in transit at the time your membership card/s arrive, you can always contact us or your fund once you arrive in Australia and ask for your cards to be reissued.
      `
    },
    {
      title: 'Is there a difference between Overseas Visitors Health Cover (OVHC) and Overseas Students Health Cover (OSHC)?',
      content: `
        Yes, there is.
        <br /><br />
        <ul class="list-disc pl-8">
          <li class="mb-2">
            <strong>Overseas Visitors Health Cover</strong> is a month to month health insurance and has limited options as to what can be included in your cover.
          </li>
          <li>
            <strong>Overseas Students Health Cover</strong> is for student visas and must be paid upfront for the length of time the visa is active. For example, if your visa is for two years, you must pay two years upfront. All people on the visa must also be included on the cover. If you want to learn more, please read our guide.
          </li>
        </ul>
      `
    }
  ],

  coverHealthLength: [
    'Less than 1 year',
    '1-3 years',
    '3-5 years',
    '5+ years'
  ],

  title: ['Mr', 'Ms', 'Mrs', 'Dr'],

  dualRateStartDate: '11/01/2023',
  dualRatesEndDate: '01/01/2024',

  allHealthFunds: [
    { 'label': 'AAMI', 'value': 'AAMI' },
    { 'label': 'ACA Health Benefits Fund', 'value': 'ACA Health Benefits Fund' },
    { 'label': 'ahm health insurance', 'value': 'ahm Health Insurance' },
    { 'label': 'AIA Health Insurance', 'value': 'AIA Health Insurance Pty Ltd' },
    { 'label': 'Apia', 'value': 'APIA' },
    { 'label': 'Astute Simplicity Health', 'value': 'Astute Simplicity Health' },
    { 'label': 'Australian Unity', 'value': 'Australian Unity' },
    { 'label': 'Bupa', 'value': 'BUPA' },
    { 'label': 'CBHS Health Fund Limited', 'value': 'CBHS' },
    { 'label': 'CBHS Corp', 'value': 'CBHS Corporate Health Pty Ltd' },
    { 'label': 'CDH Benefits Fund (known as Hunter Health)', 'value': 'Hunter Health' },
    { 'label': 'Defence Health Limited', 'value': 'Defence Health' },
    { 'label': 'Doctors\' Health Fund', 'value': 'Doctors\' Health Fund' },
    { 'label': 'Emergency Services', 'value': 'Emergency Services Health' },
    { 'label': 'Frank', 'value': 'Frank' },
    { 'label': 'GMHBA', 'value': 'GMHBA' },
    { 'label': 'GU Health', 'value': 'GU Health' },
    { 'label': 'HBF', 'value': 'HBF' },
    { 'label': 'HCF', 'value': 'HCF' },
    { 'label': 'HCI', 'value': 'Health Care Insurance Limited' },
    { 'label': 'Health Partners', 'value': 'Health Partners' },
    { 'label': 'HIF', 'value': 'HIF' },
    { 'label': 'ING', 'value': 'ING' },
    { 'label': 'Latrobe Health', 'value': 'Latrobe Health Services' },
    { 'label': 'Medibank', 'value': 'Medibank' },
    { 'label': 'Mildura Health', 'value': 'Mildura Health Fund' },
    { 'label': 'National Health Benefits Australia Pty Ltd (onemedifund)', 'value': 'Onemedifund' },
    { 'label': 'Navy Health', 'value': 'Navy Health Ltd' },
    { 'label': 'nib Health Fund', 'value': 'NIB' },
    { 'label': 'Nurses & Midwives', 'value': 'Nurses & Midwives Health' },
    { 'label': 'Peoplecare', 'value': 'Peoplecare' },
    { 'label': 'Phoenix Health', 'value': 'Phoenix Health Fund Limited' },
    { 'label': 'Police Health', 'value': 'Police Health' },
    { 'label': 'Priceline', 'value': 'Priceline' },
    { 'label': 'Qantas', 'value': 'Qantas Assure' },
    { 'label': 'Queensland Country Health Fund', 'value': 'Queensland Country Health Fund Ltd' },
    { 'label': 'Real Insurance', 'value': 'Real Insurance' },
    { 'label': 'Reserve Bank Health Society', 'value': 'Reserve Bank Health Society Ltd' },
    { 'label': 'RT Health', 'value': 'Railway and Transport Health Fund Limited' },
    { 'label': 'see-u by HBF', 'value': 'See-u by HBF' },
    { 'label': 'Seniors Insurance', 'value': 'Seniors Insurance' },
    { 'label': 'St.Lukes Health', 'value': 'St.Lukes Health' },
    { 'label': 'Suncorp', 'value': 'Suncorp' },
    { 'label': 'Teachers Health', 'value': 'Teachers Health' },
    { 'label': 'Territory Health', 'value': 'Territory Health' },
    { 'label': 'TUH Health Fund', 'value': 'Teacher\'s Union Health' },
    { 'label': 'UniHealth', 'value': 'UniHealth' },
    { 'label': 'Union Health', 'value': 'Union Health' },
    { 'label': 'Westfund Limited', 'value': 'Westfund' },
    { 'label': 'Other fund not listed', 'value': 'other' }
  ],

  healthFundProviders: [
    {
      code: 'Medibank',
      label: 'Medibank',
      value: 'Medibank',
      logo: '/images/products/health/partners/medibank.svg',
      dimensions: { width: 89, height: 17 }
    },
    {
      code: 'ahm health insurance',
      label: 'ahm health insurance',
      value: 'ahm health insurance',
      logo: '/images/products/health/partners/partner-ahm.svg',
      dimensions: { width: 60, height: 40 }
    },
    {
      code: 'BUPA',
      label: 'BUPA',
      value: 'BUPA',
      logo: '/images/products/health/partners/partner-bupa.svg',
      dimensions: { width: 40, height: 40 }
    },
    {
      code: 'HCF',
      label: 'HCF',
      value: 'HCF',
      logo: '/images/products/health/partners/partner-hcf.svg',
      dimensions: { width: 94, height: 48 }
    },
    {
      code: 'NIB',
      label: 'nib Health Fund',
      value: 'NIB',
      logo: '/images/products/health/partners/partner-nib.svg',
      dimensions: { width: 72, height: 48 }
    },
    {
      code: 'HBF',
      label: 'HBF',
      value: 'HBF',
      logo: '/images/products/health/partners/hbf.svg',
      dimensions: { width: 76, height: 48 }
    },
    {
      code: 'Teachers Health',
      label: 'Teachers Health',
      value: 'Teachers Health',
      logo: 'https://asset.compareclub.com.au/health-insurance/partners/Teachers-Health.svg',
      dimensions: { width: 64, height: 26 }
    },
    {
      code: 'Australian Unity',
      label: 'Australian Unity',
      value: 'Australian Unity',
      logo: '/images/products/health/partners/partner-australianUnity.svg',
      dimensions: { width: 80, height: 48 }
    },
    {
      code: 'Suncorp',
      label: 'Suncorp',
      value: 'Suncorp',
      logo: 'https://asset.compareclub.com.au/home-loan/partners/Suncorp.svg',
      dimensions: { width: 80, height: 48 }
    },
    {
      code: 'GMHBA',
      label: 'GMHBA',
      value: 'GMHBA',
      logo: 'https://asset.compareclub.com.au/health-insurance/partners/GMHBA.svg',
      dimensions: { width: 94, height: 48 }
    }
  ],

  hospitalCoverListAB: [
    {
      label: 'Private Hospital',
      value: 'private_hospital_shared',
      info: {
        title: 'Private Hospital',
        content: 'Private patient, private hospital admissions.'
      },
      image: '/icons/health-insurance/funnel/Hospital.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      label: 'Ambulance',
      value: 'ambulance',
      info: {
        title: 'Ambulance',
        content: 'Cover for all clinically necessary ambulance services for emergencies in Australia. This differs in states. For more details check with state Ambulance authority to ensure you have the right level of cover for non-emergency ambulance transport within Australia.'
      },
      image: '/icons/health-insurance/funnel/Ambulance.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      value: 'joint_replacement',
      label: 'Joint replacement',
      info: {
        title: 'Joint replacement',
        content: 'Hospital treatment for surgery for joint replacements, including revisions, resurfacing, partial replacements and removal of prostheses'
      },
      image: '/icons/health-insurance/funnel/Joint.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      value: 'heart_vascular',
      label: 'Heart + Vascular',
      info: {
        title: 'Heart and Vascular System',
        content: 'Hospital treatment for the investigation and treatment of the heart, heart-related conditions and vascular system.'
      },
      image: '/icons/health-insurance/funnel/Heart.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      value: 'sleep_studies',
      label: 'Sleep Studies',
      info: {
        title: 'Sleep Studies',
        content: 'Hospital treatment for the investigation of sleep patterns and anomalies. For example: sleep apnoea and snoring.'
      },
      image: '/icons/health-insurance/funnel/Sleep Studies.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      value: 'back_neck_spine',
      label: 'Back, Neck & Spine',
      info: {
        title: 'Back, Neck & Spine',
        content: 'Hospital treatment for the investigation and treatment of the back, neck and spinal column, including spinal fusion. For example: sciatica, prolapsed or herniated disc, spinal disc replacement, and spine curvature disorders such as scoliosis, kyphosis and lordosis.'
      },
      image: '/icons/health-insurance/funnel/Physiotherapy.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      value: 'chemotherapy_radiotherapy_immunotherapy',
      label: 'Chemotherapy',
      info: {
        title: 'Chemotherapy',
        content: 'Hospital treatment for chemotherapy, radiotherapy and immunotherapy of cancer. Surgical treatment of other body systems i.e. lung and chest are covered separately.'
      },
      image: '/icons/health-insurance/funnel/Cancer.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      value: 'accident_override',
      label: 'Accident (override)',
      info: {
        title: 'Accident (override)',
        content: 'Some policies offer hospital treatments that are usually Restricted or Excluded under your cover, if they\'re a result of an accident. Be aware that eligibility for this benefit differs between funds.'
      },
      image: '/icons/health-insurance/funnel/Accident Only.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      value: 'pregnancy_birth',
      label: 'Pregnancy and Birth',
      info: {
        title: 'Pregnancy and Birth',
        content: 'Hospital treatment for investigation and treatment of conditions associated with pregnancy and child birth. Treatment for the baby is covered under the clinical category relevant to their condition.'
      },
      image: '/icons/health-insurance/funnel/Pregnancy and Birth.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      value: 'cataracts',
      label: 'Cataracts',
      info: {
        title: 'Cataracts',
        content: 'Hospital treatment for surgery to remove a cataract and replace with an artificial lens.'
      },
      image: '/icons/health-insurance/funnel/Cataracts.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      label: 'Eye (not cataracts)',
      value: 'eye_not_cataracts',
      info: {
        title: 'Eye (not cataracts)',
        content: 'Hospital treatment for the investigation and treatment of the eye and the contents of the eye socket.'
      },
      image: '/icons/health-insurance/funnel/Eye.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      value: 'rehabilitation',
      label: 'Rehabilitation',
      info: {
        title: 'Rehabilitation',
        content: 'Hospital treatment for physical rehabilitation for a patient related to surgery or illness.'
      },
      image: '/icons/health-insurance/funnel/Rehabilitation.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      value: 'plastic_reconstructive_surgery',
      label: 'Plastic and Reconstructive Surgery',
      info: {
        title: 'Plastic and Reconstructive Surgery',
        content: 'Hospital treatment which is medically necessary for the investigation and treatment of any physical deformity, whether acquired as a result of illness or accident, or congenital.'
      },
      image: '/icons/health-insurance/funnel/PlasticReconstructiveSurgery.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      value: 'dialysis_chronic_kidney',
      label: 'Dialysis for Chronic Kidney Disease',
      info: {
        title: 'Dialysis for Chronic Kidney Disease',
        content: 'Hospital treatment for dialysis treatment for chronic kidney failure.'
      },
      image: '/icons/health-insurance/funnel/Kidney.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      value: 'hearing_device',
      label: 'Implantation of Hearing Devices',
      info: {
        title: 'Implantation of Hearing Devices',
        content: 'Hospital treatment to correct hearing loss, including implantation of a prosthetic hearing device.'
      },
      image: '/icons/health-insurance/funnel/Hearing Device.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      value: 'hospital_psychiatric_service',
      label: 'Hospital Psychiatric Services',
      info: {
        title: 'Hospital Psychiatric Services',
        content: 'Hospital treatment for the treatment and care of patients with psychiatric, mental, addiction or behavioural disorders.'
      },
      image: '/icons/health-insurance/funnel/Hospital Psychiatric Services.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      value: 'weight_loss_surgery',
      label: 'Weight Loss Surgery',
      info: {
        title: 'Weight Loss Surgery',
        content: 'Hospital treatment for surgery that is designed to reduce a person’s weight, remove excess skin due to weight loss and reversal of a bariatric procedure.'
      },
      image: '/icons/health-insurance/funnel/Weight Loss Surgery.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      value: 'male_reproductive_system',
      label: 'Male Reproductive System',
      info: {
        title: 'Male Reproductive System',
        content: 'Hospital treatment for the investigation and treatment of the male reproductive system including the prostate.'
      },
      image: '/icons/health-insurance/funnel/Male.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      value: 'assisted_reproductive',
      label: 'Assisted Reproductive Services',
      info: {
        title: 'Assisted Reproductive Services',
        content: 'Hospital treatment for fertility treatments or procedures.'
      },
      image: '/icons/health-insurance/funnel/Assisted Reproductive Services.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      value: 'ear_nose_throat',
      label: 'Ear, Nose and Throat',
      info: {
        title: 'Ear, Nose and Throat',
        content: 'Hospital treatment for the investigation and treatment of the ear, nose, throat, middle ear, thyroid, parathyroid, larynx, lymph nodes and related areas of the head and neck.'
      },
      image: '/icons/health-insurance/funnel/Nose & Throat.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      value: 'pain_management',
      label: 'Pain Management',
      info: {
        title: 'Pain Management',
        content: 'Hospital treatment for pain management that does not require the insertion or surgical management of a device'
      },
      image: '/icons/health-insurance/funnel/Joint 2.svg',
      imageWidth: 40,
      imageHeight: 40
    }
  ],

  extrasCoverListAB: [
    {
      label: 'General Dental',
      value: 'general_dental',
      image: '/icons/health-insurance/funnel/Dental.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      label: 'Major Dental',
      value: 'major_dental',
      image: '/icons/health-insurance/funnel/Major Dental.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      label: 'Optical',
      value: 'optical',
      image: '/icons/health-insurance/funnel/Eyeglasses-Regular.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      label: 'Physiotherapy',
      value: 'physiotherapy',
      image: '/icons/health-insurance/funnel/Physiotherapy.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      label: 'Chiropractic and Osteopathy',
      value: 'chiropractic',
      image: '/icons/health-insurance/funnel/Joint.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      label: 'Pharmaceuticals',
      value: 'pharmaceuticals',
      image: '/icons/health-insurance/funnel/Medicines.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      label: 'Remedial Massage',
      value: 'remedial_massage',
      image: '/icons/health-insurance/funnel/massage.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      label: 'Psychology',
      value: 'psychology',
      image: '/icons/health-insurance/funnel/Hospital Psychiatric Services.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      label: 'Podiatry',
      value: 'podiatry_therapy',
      image: '/icons/health-insurance/funnel/Legs.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      label: 'Acupuncture',
      value: 'acupuncture',
      image: '/icons/health-insurance/funnel/Acupuncture.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      label: 'Hearing Aids',
      value: 'hearing_aids',
      image: '/icons/health-insurance/funnel/Hearing Device.svg',
      imageWidth: 40,
      imageHeight: 40
    },
    {
      label: 'Other Aids',
      value: 'glucose_monitor',
      image: '/icons/health-insurance/funnel/Aids.svg',
      imageWidth: 40,
      imageHeight: 40
    }
  ]
}

export const SUMMARY_MAP = {
  life_stage: {
    label: 'Cover for',
    icon: 'icons/user-pin.svg'
  },
  postcode: {
    label: 'Postcode',
    icon: 'icons/location-outline.svg'
  },
  has_health_fund: {
    label: 'Insurance Cover',
    icon: 'icons/file-new.svg'
  },
  partner_has_health_fund: {
    label: 'Partner\'s Insurance Cover',
    icon: 'icons/file-new.svg'
  },
  health_cover: {
    label: 'Health Cover',
    icon: 'icons/file-new.svg'
  },
  birthdate: {
    label: 'DOB',
    icon: 'icons/home-heart.svg'
  },
  partner_birthdate: {
    label: 'Partner\'s DOB',
    icon: 'icons/home-heart.svg'
  },
  income: {
    label: 'Yearly Income',
    icon: 'icons/income.svg'
  }
}

export const ERROR_MAP = {
  full_name: 'Please enter your full name',
  life_stage: 'Please select an option',
  postcode: 'Please enter valid postcode or suburb',
  email: 'Please enter a valid email address',
  phone: 'Please enter valid phone number',
  has_health_fund: 'Please select an option',
  health_fund: 'Please select health fund',
  partner_has_health_fund: 'Please select an option',
  partner_health_fund: 'Please select health fund',
  switching_content: '',
  health_cover: 'Please select option(s)',
  birthdate: 'Please enter valid date of birth',
  partner_birthdate: 'Please enter valid date of birth',
  income: 'Please select an option',
  cover_type: 'Please select an option',
  hospital_cover_list: 'Please select the services',
  extras_cover_list: 'Please select the services'
}

export const FORM_STEPS = [
  'About You',
  'Cover Details',
  'Compare',
  'Apply',
  'Finish'
]

export const FORM_STEPS_AB = [
  'About You',
  'Cover Details',
  'Comparison',
  'Application'
]

export const FORM_HEADER = {
  step1: {
    tag: 'FREE!',
    title: `
      <strong class="font-extrabold">Health insurance</strong> quotes in
      <strong class="font-extrabold">under 2 minutes!</strong>
    `,
    component: 'div'
  },

  step2: {
    title: 'Tell us a bit more about',
    component: 'AtomsHeadline'
  },

  step3: {
    title: 'Make your <strong class="font-extrabold">health cover work</strong> for you.',
    component: 'AtomsHeadline'
  }
}

export const FORM_QUESTIONS = {
  lifeStage: {
    question: 'Your health insurance cover is for',
    desc: 'If you tell us what\'s important to you, it\'ll help us figure out the right health insurance policy for you.',

    components: [
      {
        component: 'MoleculesSelection',
        props: {
          name: 'life_stage',
          type: 'radio',
          ticker: 'circle',
          options: LIFE_STAGE
        }
      }
    ]
  },
  postcode: {
    question: 'Enter your postcode or suburb',
    desc: 'Your location can make a difference to the availability of healthcare providers allied to your current - or new - health fund.',

    components: [
      {
        component: 'MoleculesPostcode',
        props: {
          label: 'Postcode or suburb',
          validateOnBlur: true,
          'data-testid': 'postcode-input'
        }
      }
    ]
  },
  hasHealthFund: {
    question: 'Do you have health cover?',
    desc: 'This helps our experts better understand your needs and compare suitable policies from our panel. We can also factor in things like Lifetime Health Cover Loading (LHCL) if you don\'t currently hold health cover.',

    components: [
      {
        component: 'MoleculesSelection',
        props: {
          name: 'has_health_fund',
          type: 'radio',
          ticker: 'circle',
          options: ['Yes', 'No'],
          'data-testid': 'have-health-cover-radio'
        }
      }
    ]
  },
  healthFund: {
    question: 'Select your current health fund',

    components: [
      {
        component: 'MoleculesSelectDropdown',
        props: {
          label: 'Select Health Fund',
          dataListDisplay: 'label',
          dataInputDisplay: 'label',
          // dataValue: 'value',
          dataSrc: 'https://asset.compareclub.com.au/json/health-funnel-funds.json',
          'data-testid': 'current-fund-dropdown'
        }
      }
    ]
  },
  partnerHasHealthFund: {
    question: 'Does your partner have health cover?',
    desc: 'If you tell us what\'s important to you, this helps us figure out the right health insurance match for you and your partner as a couple.',

    components: [
      {
        component: 'MoleculesSelection',
        props: {
          name: 'partner_has_health_fund',
          type: 'radio',
          ticker: 'circle',
          options: ['Yes', 'No'],
          'data-testid': 'partner-has-fund-radio'
        }
      }
    ]
  },
  partnerHealthFund: {
    question: 'Select your partner\'s health fund',

    components: [
      {
        component: 'MoleculesSelectDropdown',
        props: {
          name: 'partner_health_fund',
          label: 'Select Health Fund',
          dataListDisplay: 'label',
          dataInputDisplay: 'label',
          // dataValue: 'value',
          dataSrc: 'https://asset.compareclub.com.au/json/health-funnel-funds.json',
          'data-testid': 'partner-fund-dropdown'
        }
      }
    ]
  },
  healthCover: {
    question: 'What are your main considerations when looking for new health insurance?',
    desc: 'Tell us what\'s important to you. It helps our experts find the right policy match for you. You can select multiple options.',

    components: [
      {
        component: 'MoleculesSelection',
        props: {
          type: 'checkbox',
          options: PAGE_DATA.healthCover,
          'data-testid': 'main-considerations-checkbox'
        }
      }
    ]
  },
  birthdate: {
    question: 'What is your date of birth?',
    desc: 'Your age helps us figure out what cover could be the most valuable for you.',

    components: [
      {
        component: 'MoleculesBirthdate',
        props: {
          label: 'Date of birth',
          placeholder: 'Enter your date of birth (dd/mm/yyyy)',
          validAge: PAGE_DATA.validAge,
          disableDatepicker: true,
          validateOnBlur: true,
          'data-testid': 'birthdate-input'
        }
      }
    ]
  },
  partnerBirthdate: {
    question: 'What is your partner\'s date of birth?',
    desc: 'This information helps us work out which policies are the most relevent for you and your partner.',

    components: [
      {
        component: 'MoleculesBirthdate',
        props: {
          label: 'Date of birth',
          placeholder: 'Enter your partner\'s date of birth (dd/mm/yyyy)',
          validAge: PAGE_DATA.validAge,
          disableDatepicker: true,
          validateOnBlur: true,
          'data-testid': 'partner-dob-input'
        }
      }
    ]
  },
  income: {
    question: 'What is your annual taxable income?',
    desc: 'This is to help calculate your health insurance rebate. The level of government rebate you can claim is based on your yearly household (taxable) income and your age.',

    components: [
      {
        component: 'MoleculesSelection',
        props: {
          name: 'income',
          type: 'radio',
          ticker: 'circle',
          options: [],
          'data-testid': 'income-radio'
        }
      }
    ]
  },
  coverType: {
    question: 'Select the type of Cover',
    desc: 'Choose your preferred cover type.',

    components: [
      {
        component: 'MoleculesSelection',
        props: {
          name: 'cover_type',
          type: 'radio',
          ticker: 'circle',
          options: COVER_TYPE,
          'data-testid': 'cover-type-radio'
        }
      }
    ]
  },
  hospitalCoverList: {
    question: 'What hospital services do you want covered?',
    desc: `
      Choose what services you'd like to be covered for today and into the future. We'll then find a quote that matches your needs. Need help? Our experts are on hand to answer any questions
    `,

    components: [
      {
        component: 'MoleculesSelection',
        props: {
          type: 'checkbox',
          options: PAGE_DATA.hospitalCoverList,
          inline: true,
          infoShowAction: 'hover',
          customBtnClass: 'text-semantic-surface-on-surface',
          'data-testid': 'hospital-cover-checkbox'
        }
      }
    ]
  },
  extrasCoverList: {
    question: 'What extras services do you need cover for?',
    desc: `
      Choose what services you're likely to use over the next 12 months. Got questions? Our experts are on hand to help you compare benefits, annual limits and coverage.
    `,

    components: [
      {
        component: 'MoleculesSelection',
        props: {
          type: 'checkbox',
          options: PAGE_DATA.extrasCoverList,
          inline: true,
          customBtnClass: 'text-semantic-surface-on-surface',
          'data-testid': 'extras-cover-checkbox'
        }
      }
    ]
  }
}

export const FORM_ITEMS_ARR = {
  step1: [
    'lifeStage',
    'postcode'
  ],
  step2: [
    'hasHealthFund',
    'healthFund',
    'partnerHasHealthFund',
    'partnerHealthFund',
    'healthCover',
    'birthdate',
    'partnerBirthdate',
    'income'
  ],
  step3: [
    'coverType',
    'hospitalCoverList',
    'extrasCoverList'
  ]
}

export const ERROR_MAP_STEP1 = {
  life_stage: 'Please select an option',
  postcode: 'Please enter valid postcode or suburb',
  health_cover: 'Please select an option'
}

export const FORM_QUESTIONS_STEP1 = {
  lifeStage: {
    question: 'Your health insurance cover is for',
    components: [
      {
        component: 'MoleculesSelectDropdown',
        props: {
          name: 'life_stage',
          label: 'Cover type',
          theme: 'light',
          placeholder: 'Select cover type',
          dataValue: 'value',
          dataInputDisplay: 'label',
          dataListDisplay: 'label',
          dataArr: LIFE_STAGE,
          'data-testid': 'lifestage-dropdown'
        }
      }
    ]
  },
  postcode: {
    question: 'Enter your postcode',
    components: [
      {
        component: 'MoleculesPostcode',
        props: {
          placeholder: 'Enter postcode',
          label: 'Postcode or suburb',
          theme: 'light',
          validateOnBlur: true,
          'data-testid': 'postcode-input'
        }
      }
    ]
  },
  healthCover: {
    question: 'Main motivation',
    components: [
      {
        component: 'MoleculesSelectDropdown',
        props: {
          name: 'health_cover',
          label: 'Main motivation',
          theme: 'light',
          placeholder: 'What is your motivation?',
          dataValue: 'value',
          dataInputDisplay: 'label',
          dataListDisplay: 'label',
          dataArr: PAGE_DATA.healthCover
        }
      }
    ]
  }
}
export const FORM_ITEMS_ARR_STEP1 = {
  step1: [
    'lifeStage',
    'postcode',
    'healthCover'
  ]

}

// A/B Test Variant - Based on Figma Design (Health-Funnel-Master-Design)
export const FORM_QUESTIONS_AB = {
  // Step 0: Your health insurance cover is for
  lifeStage: {
    question: 'Your health insurance cover is for',
    components: [
      {
        component: 'MoleculesSelectDropdown',
        props: {
          name: 'life_stage',
          label: 'Cover type',
          theme: 'light',
          placeholder: 'Select cover type',
          dataValue: 'value',
          dataInputDisplay: 'label',
          dataListDisplay: 'label',
          dataArr: LIFE_STAGE
        }
      }
    ]
  },
  // Step 1: What is your postcode?
  postcode: {
    question: 'What is your postcode?',
    components: [
      {
        component: 'MoleculesPostcode',
        props: {
          label: '',
          validateOnBlur: true,
          mobileKeyboardType: 'numeric',
          truncateText: true
        }
      }
    ]
  },

  // Step 2: Do you have private health cover?
  hasHealthFund: {
    question: 'Do you have private health cover?',
    components: [
      {
        component: 'V2AtomsSelection',
        props: {
          name: 'has_health_fund',
          type: 'radio',
          cols: 2,
          mobileCols: 2,
          ticker: 'none',
          direction: 'row',
          imagePosition: 'top',
          size: 'small',
          options: [
            {
              value: 'Yes',
              label: 'Yes',
              name: 'yes',
              image: '/icons/ThumbsUp.svg',
              imageWidth: 40,
              imageHeight: 40
            },
            {
              value: 'No',
              label: 'No',
              name: 'no',
              image: '/icons/ThumbsDown.svg',
              imageWidth: 40,
              imageHeight: 40
            }
          ]
        }
      }
    ]
  },

  // Step 3: What is your current health fund? (conditional - shown when hasHealthFund === 'Yes')
  healthFund: {
    question: 'What is your current health fund?',
    desc: 'Choose your current fund from the logos or list below',
    components: [
      {
        component: 'OrganismsProviderLogoSelection',
        props: {
          name: 'health_fund',
          label: 'Select Health Fund',
          theme:'light',
          dataListDisplay: 'label',
          dataInputDisplay: 'label',
          dataArr: PAGE_DATA.allHealthFunds,
          errorMsg: 'Please select a health insurance provider.',
          required: true,
          gridColumns: 5,
          gridGap: 'gap-4',
          borderVariant: 'variant',
          dropdownSize: 'compact',
          dividerVariant: 'compact',
          dividerText: 'or',
          containerBackground: 'bg-semantic-surface-container-lowest',
          searchable: true,
          providers: PAGE_DATA.healthFundProviders,
          mobileLimit: 9
        }
      }
    ]
  },

  // Step 4: Does your partner have private health cover? (Only for Couple/Family)
  partnerHasHealthFund: {
    question: 'Does your partner have private health cover?',
    components: [
      {
        component: 'V2AtomsSelection',
        props: {
          name: 'partner_has_health_fund',
          type: 'radio',
          cols: 2,
          mobileCols: 2,
          ticker: 'none',
          direction: 'row',
          imagePosition: 'top',
          size: 'small',
          options: [
            {
              value: 'Yes',
              label: 'Yes',
              name: 'yes',
              image: '/icons/ThumbsUp.svg',
              imageWidth: 40,
              imageHeight: 40
            },
            {
              value: 'No',
              label: 'No',
              name: 'no',
              image: '/icons/ThumbsDown.svg',
              imageWidth: 40,
              imageHeight: 40
            }
          ]
        }
      }
    ]
  },
  // Step 5: What is your partner's current health fund? (conditional - shown when partnerHasHealthFund === 'Yes', Only for Couple/Family)
  partnerHealthFund: {
    question: 'What is your partner\'s current health fund?',
    desc: 'Choose your current fund from the logos or list below',
    components: [
      {
        component: 'OrganismsProviderLogoSelection',
        props: {
          name: 'partner_health_fund',
          label: 'Select Health Fund',
          theme:'light',
          dataListDisplay: 'label',
          dataInputDisplay: 'label',
          dataArr: PAGE_DATA.allHealthFunds,
          errorMsg: 'Please select a health insurance provider.',
          required: true,
          gridColumns: 5,
          gridGap: 'gap-4',
          borderVariant: 'variant',
          dropdownSize: 'compact',
          dividerVariant: 'compact',
          dividerText: 'or',
          containerBackground: 'bg-semantic-surface-container-lowest',
          searchable: true,
          providers: PAGE_DATA.healthFundProviders,
          mobileLimit: 9
        }
      }
    ]
  },

  // Step 6: What is important to you? (For all life_stage types)
  healthCover: {
    question: 'What is important to you?',
    desc: 'You can select multiple',
    components: [
      {
        component: 'V2AtomsSelection',
        props: {
          name: 'health_cover',
          type: 'checkbox',
          cols: 4,
          mobileCols: 2,
          ticker: 'square',
          tickerSize: 'small',
          tickerPosition: 'top',
          imagePosition: 'top',
          size: 'extraSmall',
          options: PAGE_DATA.healthCoverFunnelAB
        }
      }
    ]
  },
  // Step 7: What is your date of birth? (For all life_stage types)
  birthdate: {
    question: 'What is your date of birth?',
    components: [
      {
        component: 'MoleculesBirthdate',
        props: {
          label: 'Date of birth',
          placeholder: 'DD/MM/YYYY',
          validAge: PAGE_DATA.validAge,
          disableDatepicker: true,
          validateOnBlur: true,
          mobileKeyboardType: 'numeric'
        }
      }
    ]
  },

  // Step 8: What is your partner's date of birth? (Only for Couple/Family)
  partnerBirthdate: {
    question: 'What is your partner\'s date of birth?',
    desc: 'This information helps us work out which policies are the most relevant for you and your partner.',
    components: [
      {
        component: 'MoleculesBirthdate',
        props: {
          label: 'Date of birth',
          placeholder: 'DD/MM/YYYY',
          validAge: PAGE_DATA.validAge,
          disableDatepicker: true,
          validateOnBlur: true,
          mobileKeyboardType: 'numeric'
        }
      }
    ]
  },

  // Step 9: What's your household's annual taxable income? (For all life_stage types)
  income: {
    question: 'What\'s your household\'s annual taxable income?',
    desc: 'Used to calculate your Australian Government rebate and reduce the cost of your cover',

    components: [
      {
        component: 'V2AtomsSelection',
        props: {
          name: 'income',
          type: 'radio',
          ticker: 'none',
          options: []
        }
      }
    ]
  },

  // Step 10: What cover would you like? (For all life_stage types)
  coverType: {
    question: 'What cover would you like?',
    components: [
      {
        component: 'V2AtomsSelection',
        props: {
          name: 'cover_type',
          type: 'radio',
          ticker: 'none',
          options: [
            {
              label: 'Hospital & Extras',
              value: 'Combined',
              description: 'Combines hospital cover with extras like physio, dental, optical, psychology and more.'
            },
            {
              label: 'Hospital only',
              value: 'Hospital',
              description: 'A hospital policy covers you for in-hospital procedures, treatments and accommodation.'
            },
            {
              label: 'Extras only',
              value: 'Extras',
              description: 'Extras cover provides rebates for services like physio, dental, optical, psychology and more.'
            }
          ]
        }
      }
    ]
  },

  // Step 11: Select hospital services (Conditional based on coverType - Hospital or Combined)
  hospitalCoverList: {
    question: 'Select hospital services',
    desc: 'All selected services will be covered in a Private Hospital. Ambulance cover is excluded for QLD residents, as it is provided by the state.',
    components: [
      {
        component: 'V2AtomsSelection',
        props: {
          name: 'hospital_cover_list',
          type: 'checkbox',
          cols: 4,
          mobileCols: 2,
          ticker: 'square',
          tickerSize: 'small',
          tickerPosition: 'top',
          imagePosition: 'top',
          size: 'extraSmall',
          options: PAGE_DATA.hospitalCoverListAB,
          listLimit: 7,
          toggleStyle: 'inline',
          infoIconPosition: 'absolute-top-right',
          infoIconSize: 'small',
          infoTooltipClass: 'lg:!max-w-[20rem] !max-w-[10rem]'
        }
      }
    ]
  },

  // Step 12: Select extras services (Conditional based on coverType - Extras or Combined)
  extrasCoverList: {
    question: 'Select extras services',
    desc: 'You can select multiple',
    components: [
      {
        component: 'V2AtomsSelection',
        props: {
          name: 'extras_cover_list',
          type: 'checkbox',
          cols: 4,
          mobileCols: 2,
          ticker: 'square',
          tickerSize: 'small',
          tickerPosition: 'top',
          imagePosition: 'top',
          size: 'extraSmall',
          options: PAGE_DATA.extrasCoverListAB,
          listLimit: 7,
          toggleStyle: 'inline',
          infoIconPosition: 'absolute-top-right',
          infoIconSize: 'small',
          infoTooltipClass: 'lg:!max-w-[20rem] !max-w-[10rem]'
        }
      }
    ]
  }

}

export const FORM_ITEMS_ARR_AB = {
  step0: ['lifeStage'],
  step1: ['postcode'],
  step2: ['hasHealthFund'], // Do you have health cover?
  step3: ['healthFund'], // What is your current health fund? (shown when hasHealthFund === 'Yes')
  step4: ['partnerHasHealthFund'], // Does your partner have health cover? (Only for Couple/Family)
  step5: ['partnerHealthFund'], // What is your partner's health fund? (Only for Couple/Family, shown when partnerHasHealthFund === 'Yes')
  step6: ['healthCover'], // What is important to you?¸
  step7: ['birthdate'], // Your date of birth (For all life_stage types)
  step8: ['partnerBirthdate'], // Partner's date of birth (Only for Couple/Family)
  step9: ['income'], // Annual taxable income
  step10: ['coverType'], // What cover would you like?
  step11: ['hospitalCoverList'], // Hospital services (conditional)
  step12: ['extrasCoverList'] // Extras services (conditional)
}

export const ERROR_MAP_AB = {
  full_name: 'Please enter your full name',
  life_stage: 'Please select an option',
  postcode: 'Please enter valid postcode or suburb',
  email: 'Please enter a valid email address',
  phone: 'Please enter valid phone number',
  has_health_fund: 'Please select an option',
  health_fund: 'Please select health fund',
  partner_has_health_fund: 'Please select an option',
  partner_health_fund: 'Please select health fund',
  health_cover: 'Please select option(s)',
  cover_type: 'Please select an option',
  hospital_cover_list: 'This benefit is included by default in all hospital cover options.',
  extras_cover_list: 'Please select the services',
  birthdate: 'Please enter valid date of birth',
  partner_birthdate: 'Please enter valid date of birth',
  income: 'Please select an option',
  income_tier: 'Please select an option'
}